import { axiosInstance } from '@/lib/utils';
import type { ChatbotSettingsPayload } from './payload';
import type { ChatbotSettingsResponse } from './response';
import { endpoints } from '@/api';

export const updateChatbotSettings = async (
  payload: ChatbotSettingsPayload
) => {
  const response = await axiosInstance.post<ChatbotSettingsResponse>(
    endpoints.chatbot.settings,
    payload
  );
  return response.data;
};
